// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICianApiSiteV1SearchRegionsCitiesRequest,
  TCianApiSiteV1SearchRegionsCitiesModel,
  IMappers,
  TCianApiSiteV1SearchRegionsCitiesResponse,
  ICianApiSiteV1SearchRegionsCitiesResponse,
  ICianApiSiteV1SearchRegionsCitiesResponseError,
} from './types';

export const defaultConfig: TCianApiSiteV1SearchRegionsCitiesModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/search-regions-cities/',
} as TCianApiSiteV1SearchRegionsCitiesModel;

export function createCianApiSiteV1SearchRegionsCitiesModel(
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
): TCianApiSiteV1SearchRegionsCitiesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICianApiSiteV1SearchRegionsCitiesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest;
}

export async function fetchCianApiSiteV1SearchRegionsCities<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1SearchRegionsCitiesOptions<TResponse200, TResponse400>): Promise<
  TCianApiSiteV1SearchRegionsCitiesResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createCianApiSiteV1SearchRegionsCitiesModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICianApiSiteV1SearchRegionsCitiesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICianApiSiteV1SearchRegionsCitiesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCianApiSiteV1SearchRegionsCitiesResponse;
}
